var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.size,{tag:"component",class:"anx-title size-" + _vm.size + " " +
      (_vm.noMargin !== null ? 'no-margin ' : '') +
      (_vm.noline !== null ? 'no-line ' : ''),style:(_vm.cssProps)},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }